export const enum ZoneType {
    enforced = 'enforced',
    barrier_gate = 'barrier_gate',
}
